import { Box, Flex } from '@chakra-ui/react';
import RSSpinner from './RSSpinner';
import FalseSiteFooter from './SiteFooter/FalseSiteFooter';
import FalseSiteHeader from './SiteHeader/FalseSiteHeader';

const LoadingPage = () => {
  const dummyObj = {};
  return (
    <>
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 2,
          backgroundColor: 'black',
          opacity: '35%',
        }}
      />
      <Flex
        sx={{
          minHeight: '100vh',
          flexBasis: '100vh',
          alignItems: 'space-between',
          flexDirection: 'column',
        }}
      >
        <FalseSiteHeader />
        <RSSpinner
          hasLoading={true}
          stateProps={dummyObj}
          message={''}
        />
        <FalseSiteFooter />
      </Flex>
    </>
  );
};

export default LoadingPage;
